import React, {useCallback, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {aiInterpApi} from './api'
import type {PendingFeedbackDto} from './types'
import {AIFeedbackForm} from './AIFeedbackForm'
import {useAuth} from '../auth'
import {useAWSConnect} from '../../context/ConnectStreamsContext'

export const PendingFeedbackGate: React.FC = () => {
  const {currentUser} = useAuth()
  const {isMasterTab} = useAWSConnect()
  const isInterpreter = currentUser?.result?.userType === 'INTERPRETER'
  const feedbackRequired = currentUser?.result?.aiInterpretationRequiredFeedback === true
  const [pending, setPending] = useState<PendingFeedbackDto | null>(null)

  const refresh = useCallback(async () => {
    try { setPending(await aiInterpApi.getPending()) } catch { /* ignore */ }
  }, [])
  useEffect(() => {
    if (!feedbackRequired) {
      setPending(null)
      return
    }
    refresh()
  }, [refresh, feedbackRequired])
  useEffect(() => {
    const handler = () => { refresh() }
    window.addEventListener('ai-interpretation:feedback-pending-changed', handler)
    return () => window.removeEventListener('ai-interpretation:feedback-pending-changed', handler)
  }, [refresh])

  // After submit, signal the auth layer to re-fetch /loggeduser so
  // canAccessAIInterpretation flips to false the moment the user hits their
  // cap — and the sidebar menu item hides without a refresh. We use a window
  // event instead of importing useAuth to keep this module decoupled from
  // the heavy auth bundle (Amazon Connect, etc.).
  const handleSubmitted = useCallback(() => {
    setPending(null)
    window.dispatchEvent(new Event('auth:refresh-current-user'))
  }, [])

  if (!feedbackRequired || !pending) return null
  if (isInterpreter && isMasterTab !== true) return null
  return (
    <Modal
      show={true}
      backdrop='static'
      keyboard={false}
      centered
      size='lg'
    >
      <Modal.Header>
        <Modal.Title>Feedback required — please submit before continuing</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AIFeedbackForm pending={pending} onSubmitted={handleSubmitted} />
      </Modal.Body>
    </Modal>
  )
}
